<template>
    <div class="d-block d-sm-inline-block d-md-flex align-items-center">
        <h2 v-if="contractAccessibility" class="visually-hidden">
            {{ contractAccessibility }}
        </h2>
        <ob1-capsule
            v-if="contractInfos.currentContract"
            :label="contractLabel"
            :aria-hidden="true"
            is-information
            data-cs-encrypt
        />
        <template v-if="contractInfos.contractInfosLink">
            <template v-if="contractListInfos">
                <ob1-liens
                    modal-id="contracts-list-popin"
                    :text="contractInfos.contractInfosLink.contractsLinkLabel"
                    :with-arrow="true"
                    :is-mini="true"
                    :is-button="true"
                    class="d-inline-block my-1 my-md-0 text-nowrap"
                />
                <contract-selector-popin
                    id="contracts-list-popin"
                    :contracts="contractListInfos.contracts"
                    :contract-popin-dto="contractListInfos.contractPageInfosDto"
                />
            </template>
            <template v-else>
                <ob1-liens
                    id="contracts-link"
                    :text="contractInfos.contractInfosLink.contractsLinkLabel"
                    :href="contractInfos.contractInfosLink.contractsLink"
                    :with-arrow="true"
                    :is-mini="true"
                    class="d-inline-block my-1 my-md-0 text-nowrap"
                />
            </template>
        </template>
    </div>
</template>

<script>
import ContractSelectorPopin from "./ContractSelectorPopin.vue";

export default {
    name: "ContractPhoneLines",
    components: {ContractSelectorPopin},
    props: {
        contractInfos: {
            type: Object,
            required: true
        },
        contractListInfos: {
            type: Object,
            required: false,
            default: null
        }
    },
    computed: {
        contractAccessibility() {
            if (this.contractLabel) {
                return "Rappel du contrat en cours : " + this.contractLabel;
            } else return null;
        },
        localizedMsisdn: function () {
            return PhoneFormatter.toFrench(this.contractInfos.currentContract.msisdn);
        },
        localizedNdip: function () {
            return PhoneFormatter.toFrench(this.contractInfos.currentContract.ndip);
        },
        contractIdentifier: function () {
            // Si Mobile ou Open on affiche MSISDN
            if (this.contractInfos.currentContract.msisdn) {
                return this.localizedMsisdn;
            } else if (this.contractInfos.currentContract.ndip) {
                return this.localizedNdip;
            } else return null;
        },
        contractLabel: function () {
            if (this.contractInfos.currentContract) {
                return this.contractInfos.currentContract.contractsIdentifierLabel + this.contractIdentifier;
            } else return null;

        }
    },
}
</script>

<style scoped>

</style>
